import moment from 'moment-timezone';
import { useI18n } from 'vue-i18n'
export function isMobile() {
    const userAgent = navigator.userAgent.toLowerCase();
    const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'windows phone'];
    return mobileKeywords.some((keyword) => userAgent.includes(keyword));
  }
  

  export function  maskName (name)  {

    // if (name.length <= 1) {
    //     return name; // 名字长度小于等于1时，不插入星号
    // }
    const middleIndex = Math.ceil(name.length / 2) - 1;

    const start = name.slice(0, 1);
    const end = name[name.length - 1];

    return `${start}***${end}`;
}

export function formatToLocalTime(timeStamp, timeZone) {
  // const shiqu = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return moment.tz(timeZone,timeStamp).format('YYYY-MM-DD HH:mm:ss');

}
export function formatToLocalTimeYMD(timeStamp, timeZone) {
  // const shiqu = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  return moment.tz(timeZone,timeStamp).format('YYYY-MM-DD');

}
/**
 * 
 * @param {*} num 价格
 * @param {*} symbol 币种
 * @param {*} rate 汇率
 * @returns 
 */
export function exchangeRate(num,symbol,rate) {

  let result = num * rate; // 计算结果并乘以100

  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if (symbol === '¥') {
    return '';
  } else {
    if(stringNumber[decimalIndex + 3]>0){
      return `${symbol}${Math.ceil((num*rate)* 100) / 100 }`//向上取整
    }else{
      return `${symbol}${result.toFixed(2)}`;//两位取两位
    }
   
  }
  
}

/**
 * 
 * @param {*} num 价格
 * @param {*} symbol 币种
 * @param {*} rate 汇率
 * @returns 
 */
export function estimationRate(num,symbol,rate) {

  let result = num * rate; // 计算结果并乘以100

  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if (symbol === '¥') {
    return `${symbol}${num}`;
  } else {
    if(stringNumber[decimalIndex + 3]>0){
      return `${symbol}${Math.ceil((num*rate)* 100) / 100 }`//向上取整
    }else{
      return `${symbol}${result.toFixed(2)}`;//两位取两位
    }
   
  }
  
}
/**
 * 订单处理金额（人民币兑其他币种）
 * 汇率{
  "currency": "USD",
  "rate": "0.13825",
  "change": "7.2332",
  "symbol": "$"
} 
 * @param {*} num 价格
 * @param {*} symbol 符号
 * @param {*} Currency 币种
 * @param {*} rate 汇率（人民币兑其他币*rate，其他币兑人民币*change）
 * @returns 
 */
export function exchangeOrderRate(num,symbol,Currency,rate) {

  let result = num * rate; // 计算结果并乘以100
  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if(stringNumber[decimalIndex + 3]>0){
    return `${symbol}${Math.ceil((num*rate)* 100) / 100 }`//向上取整
  }else{
    return `${symbol}${result.toFixed(2)}`;//两位取两位
  }
}
export function exchangeOrderRateNum(num,symbol,Currency,rate) {

  let result = num * rate; // 计算结果并乘以100
  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if(stringNumber[decimalIndex + 3]>0){
    return Math.ceil((num*rate)* 100) / 100//向上取整
  }else{
    return result.toFixed(2);//两位取两位
  }
}
/**
 * 订单合计
 * @param {*} num 
 * @param {*} symbol 
 * @param {*} rate 
 * @returns 
 */
export function exchangeOrderTotalRate(num,buy_num,symbol,Currency,rate) {

  let result = num * rate; // 计算结果并乘以100
  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if(stringNumber[decimalIndex + 3]>0){
    let numzhi=Math.ceil((num*rate)* 100) / 100;
    let Total= numzhi*buy_num;//合计值
    const stringTotal = Total.toString();
    let TotalIndex = stringTotal.indexOf('.');
    if(stringTotal[TotalIndex + 3]>0){
      return `${Math.ceil((numzhi*buy_num)* 100) / 100 }`//向上取整
    }else{
      return `${Total.toFixed(2)}`;//两位取两位
    }
  }else{
    let numzhi=result.toFixed(2);
    let Total= numzhi*buy_num;//合计值
    const stringTotal = Total.toString();
    let TotalIndex = stringTotal.indexOf('.');
    if(stringTotal[TotalIndex + 3]>0){
      return `${Math.ceil((numzhi*buy_num)* 100) / 100 }`//向上取整
    }else{
      return `${Total.toFixed(2)}`;//两位取两位
    }
  }
}
export function goRate(num,symbol,rate) {

  let result = num * rate; // 计算结果并乘以100

  const stringNumber = result.toString();
  let decimalIndex = stringNumber.indexOf('.');
 
  if (symbol === '¥') {
    return '';
  } else {
    if(stringNumber[decimalIndex + 3]>0){
      return `${Math.ceil((num*rate)* 100) / 100 }`//向上取整
    }else{
      return `${result.toFixed(2)}`;//两位取两位
    }
  }
  
}
/**
 * 数据取值，判断是取2位还是向上取整
 * @param {*} num 
 * @returns 
 */
export function valueRange(num) {
  const stringNumber = num.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if(stringNumber[decimalIndex + 3]>0){
    return `${Math.ceil(num* 100) / 100 }`//向上取整
  }else{
    return `${num.toFixed(2)}`;//两位取两位
  }
}
export function countdown(seconds) {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secondsRemaining = seconds % 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${secondsRemaining.toString().padStart(2, '0')}`;
 
}
export function goUp(number) {
 
  const stringNumber = number.toString();
  let decimalIndex = stringNumber.indexOf('.');
  if(stringNumber[decimalIndex + 3]>0){
    return Math.ceil(number * 100) / 100;//向上取整
  }else{
    return `${number.toFixed(2)}`;//两位取两位
  }
 
}

/**
 * 美元兑换其他币种
 * @param {*} num 金额
 * @param {*} currency 币种
 * @param {*} USDrate 美元转其他汇率
 */
export function exchangeRateUSD(num,currency,USDrate){
  console.log(currency)
  if(currency!='USD'){
    let result=num * USDrate[currency]
    return Number(result.toFixed(3).slice(0, -1));//两位取两位
  }else{
    return num;
  }
}
/**
 * 币种
 * @param {} type 
 * @returns 
 */
export function symbolStatus(type){
  const stateMap = {
      'USD': '$',
      'EUR': '€',
      'CAD': 'C$',
      'CNY': '￥',
  }
  return stateMap[type]
}
/**
 * 订单状态
 * @param {} payState 
 * @returns 
 */
export function fomartPayState (payState) {
  const { t } = useI18n();
  const stateMap = {
      0: t('number31'),//未支付
      10: t('number74'),//已取消
      20: t('setup56'),//已付款
      30: t('number73'),//已完成
      40: t('number76'),//全部发货
      41: t('setup677'),//全部发货
      50:t('setup490'),//已入库
      51:t('setup491'),//运费已报价
      52:t('setup492'),//已支付运费
      53:t('setup493'),//已出库
  }
  return stateMap[payState]
}
//支付状态
export function  payState(State){
  const { t } = useI18n();
  const stateMap = {
      1: t('setup46'),
      2: t('setup47'),
      3: t('setup102'),
      4:'steadyPay',
      5:t('setup655'),
      6:'Google Pay',
      7:'Apple Pay',
      8:'PayPal'
     
  }
  return stateMap[State]
}
export function RateUSD(currency,USDrate){
  return USDrate[currency]
}

export function DEPLOY(num){ 
return num / 1000000
}

// 自定义防抖函数
export function debounce(func, delay) {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}



